import React from 'react';
import TopStepAccountPage from './TopStepAccountPage';

const TopStepAccount2Page: React.FC = () => (
  <TopStepAccountPage
    accountLabel="TopStep Account 2 (Kevin)"
    accountMatcher={(accts) => accts.find(a => a.accountName.includes('572700-94071834'))}
    challengeParams={{ target: 4500, hardMax: 2000, internalStop: 1700, dailyCap: 600, accountSize: 50000 }}
    chipLabel="ACCOUNT 2"
    chipColor="#4FC3F7"
  />
);

export default TopStepAccount2Page;
